class StickyAtc extends HTMLElement {
  connectedCallback() {
    let productSection = document.getElementById('product-' + this.dataset.productId);
    if (!productSection) return;

    let originalBtn = productSection.querySelector('.AddtoCart');
    let stickyBtn = this.querySelector('.sticky-atc__btn');
    let btnLabel = this.querySelector('.sticky-atc__btn-label');
    let btnPrice = this.querySelector('.sticky-atc__btn-price');
    let mainPrice = productSection.querySelector('.price-item.price-item--regular');
    let variantInput = productSection.querySelector('.formVariantId');

    if (!originalBtn || !stickyBtn) return;

    new IntersectionObserver((entries) => {
      let visible = entries[0].isIntersecting;
      this.classList.toggle('is-visible', !visible);
      this.setAttribute('aria-hidden', visible ? 'true' : 'false');
    }, { threshold: 0.5 }).observe(originalBtn);

    stickyBtn.addEventListener('click', () => {
      originalBtn.click();
    });

    new MutationObserver(() => {
      stickyBtn.disabled = originalBtn.disabled;
      if (btnLabel) btnLabel.textContent = originalBtn.textContent.trim();
    }).observe(originalBtn, { attributes: true, childList: true });

    if (variantInput) {
      variantInput.addEventListener('change', () => {
        let price = mainPrice ? mainPrice.textContent.trim() : '';
        this.dispatchEvent(new CustomEvent('sticky-atc:variant-change', {
          bubbles: true,
          detail: { price }
        }));
      });
    }

    this.addEventListener('sticky-atc:variant-change', (e) => {
      if (btnPrice) btnPrice.textContent = e.detail.price;
    });

    if (btnPrice && mainPrice) {
      btnPrice.textContent = mainPrice.textContent.trim();
    }
  }
}

customElements.define('sticky-atc', StickyAtc);
